import React from 'react';
import { NavLink } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import HtmlContentBlock from 'components/HtmlContentBlock';
import CompanyLogo from 'components/CompanyLogo';
import LinkBuilder from 'helpers/link-builder';

import './styles.css';

const ProjectDetails = props => {
  const {
    project,
    showDeadlineSendInBound = true,
    showBaseStartDate = false,
  } = props;
  const { FirmName, FirmActive, FirmUrlAlias, FirmLogo } = project.firm;

  return (
    <div className="project-details">
      <div className="project-details__header">
        <div className="project-details__row">
          <div className="project-details__logo">
            <CompanyLogo
              name={FirmName}
              logo={FirmLogo}
              link={LinkBuilder.getFirmLink(FirmUrlAlias)}
              styles={{
                width: '110px',
                height: '110px',
                fontSize: '0.9286rem',
              }}
            />
          </div>

          <div className="project-details__header-content">
            <div className="project-details__row">
              <h2 className="project-details__title">
                {project.PositionTitle}
              </h2>
            </div>
            <div className="project-details__row">
              {FirmActive === 'Yes' ? (
                <NavLink
                  to={LinkBuilder.getFirmLink(FirmUrlAlias)}
                  className="project-details__firm"
                >
                  {FirmName}
                </NavLink>
              ) : (
                <strong className="project-details__firm-strong">
                  {FirmName}
                </strong>
              )}
            </div>
            <div className="project-details__row project-details__row--fulwidth">
              <span className="project-details__start-date">
                {`Start Date: ${
                  showBaseStartDate ? project.baseStartDate : project.startDate
                }`}
              </span>
              <span className="project-details__date">{`Posted: ${
                project.DateAdd
              }`}</span>
            </div>
            <div className="project-details__row">
              {project.AppDeadline === 'Yes' &&
                (!project.AppDeadlinePassed || !showDeadlineSendInBound ? (
                  <span className="project-details__deadline">{`Application Deadline: ${
                    project.AppDeadlineDate
                  }`}</span>
                ) : (
                  <span className="project-details__deadline project-details__deadline--passed">
                    The application deadline has passed and{' '}
                    {project.firm.FirmName} has begun evaluating candidates.
                    Send an InBound to express your interest mid-process.
                  </span>
                ))}
            </div>
          </div>
        </div>
      </div>

      <div className="project-details__main">
        {project.ProjectType && (
          <div className="project-details__content">
            <h3 className="project-details__heading">Type</h3>
            <p className="project-details__text">{project.ProjectType}</p>
          </div>
        )}

        {project.ProjectLocation && (
          <div className="project-details__content">
            <h3 className="project-details__heading">Location</h3>
            <p className="project-details__text">{project.ProjectLocation}</p>
          </div>
        )}

        {project.ProjectIntensity && (
          <div className="project-details__content">
            <h3 className="project-details__heading">
              Intensity (weekly hours)
            </h3>
            <p className="project-details__text">{project.ProjectIntensity}</p>
          </div>
        )}

        {project.ProjectDuration && (
          <div className="project-details__content">
            <h3 className="project-details__heading">Duration (days)</h3>
            <p className="project-details__text">{project.ProjectDuration}</p>
          </div>
        )}

        {project.ProjectCompensation && (
          <div className="project-details__content">
            <h3 className="project-details__heading">Compensation</h3>
            <p className="project-details__text">
              {`${project.ProjectCompensation} ${project.CurrencyName}`}
            </p>
          </div>
        )}

        {project.ProjectCompensationDetails && (
          <div className="project-details__content">
            <h3 className="project-details__heading">
              Compensation Additional Details
            </h3>
            <p className="project-details__text">
              {project.ProjectCompensationDetails}
            </p>
          </div>
        )}

        {project.ProjectDeliverables && (
          <div className="project-details__content">
            <h3 className="project-details__heading">Deliverables</h3>
            <HtmlContentBlock content={project.ProjectDeliverables} />
          </div>
        )}

        {project.AboutUs && (
          <div className="project-details__content">
            <h3 className="project-details__heading">About Us</h3>
            <HtmlContentBlock content={project.AboutUs} />
          </div>
        )}

        {project.Descriptions && (
          <div className="project-details__content">
            <h3 className="project-details__heading">Description</h3>
            <HtmlContentBlock content={project.Descriptions} />
          </div>
        )}

        {project.additionalDetails && (
          <div className="project-details__content">
            <h3 className="project-details__heading">Additional Details</h3>
            <HtmlContentBlock content={project.AdditionalDetails} />
          </div>
        )}

        {!isEmpty(project.AdditionalOptions) && (
          <div className="project-details__content">
            <h3 className="project-details__heading">Additional Options</h3>
            <div className="project-details__text">
              {Object.keys(project.AdditionalOptions).map(key => (
                <div key={`pre_${key}`}>{project.AdditionalOptions[key]}</div>
              ))}
            </div>
          </div>
        )}
      </div>

      {project.IsClosed === 'Yes' && (
        <div className="project-details__closed-warning">
          <p>Thank you for your interest. This position has been filled</p>
        </div>
      )}
    </div>
  );
};

export default ProjectDetails;
